import type { Order } from "../types";

type VariantOption = { name: string; value: string };
type Variant = { id: string; selectedOptions: VariantOption[] };
type Product = { variants: Variant[] };

/**
 * Resolves the human-readable label of the chosen exchange variant (e.g. "M / Blue")
 * from the order's `variantByLineItemId` collection. Returns null when the variant
 * can't be found or only carries the placeholder "Default Title" option.
 */
export function getExchangeVariantLabel(
  order: Order | null,
  lineItemId: string,
  exchangeVariantId: string,
): string | null {
  const collection = (order as unknown as Record<string, unknown>)
    ?.variantByLineItemId as
    | Record<string, { products: Product[] }>
    | undefined;
  const products = collection?.[lineItemId]?.products ?? [];
  for (const product of products) {
    const variant = product.variants.find((v) => v.id === exchangeVariantId);
    if (variant) {
      return (
        variant.selectedOptions
          .map((o) => o.value)
          .filter((v) => v !== "Default Title")
          .join(" / ") || null
      );
    }
  }
  return null;
}
